import React from 'react'
import styled from 'styled-components'

export const createScrollContainer = (width, height) =>
  styled.div`
    max-width: ${width}px;
    overflow-y: auto;
    max-height: ${height}px;
  `
